import React from 'react';
import type { LayoutComponentLocation } from '../types/aha-editor';
import type AhaEditor from '../AhaEditor';

interface EditorLayoutComponentProps {
  ahaEditor: AhaEditor;
  location: LayoutComponentLocation;
}

const EditorLayoutComponents: React.FC<EditorLayoutComponentProps> = ({
  ahaEditor,
  location,
}) => {
  const components = ahaEditor.getLayoutComponents(location);

  const layoutComponents = components.map((component, index) => {
    const { Component } = component;

    // Using `index` as the key is not generally encouraged, but in this case the indexes of the components should be
    // relatively stable, and individual components will be returning `null` when it is not to be rendered.
    return <Component key={index} />;
  });

  return <>{layoutComponents}</>;
};

export default EditorLayoutComponents;
